import { Stack } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";
import { WordsDiff } from "@/components/WordsDiff";
import { EncounterServiceDateDiffContext } from "@/encounters/utils/encounter-service-date-diff";

interface EncounterServiceDateDiffFieldsProps {
  diff: EncounterServiceDateDiffContext;
  variant: "previous" | "amended";
}

export default function EncounterServiceDateDiffFields({
  diff,
  variant,
}: EncounterServiceDateDiffFieldsProps) {
  const showRemoved = variant === "previous";

  return (
    <>
      <Stack gap="0">
        <TextWrapper fw={600}>Date</TextWrapper>
        <WordsDiff
          showRemoved={showRemoved}
          current={diff.current.date}
          previous={diff.previous.date}
        />
      </Stack>
      <Stack gap="0">
        <TextWrapper fw={600}>Time</TextWrapper>
        <WordsDiff
          showRemoved={showRemoved}
          current={diff.current.time}
          previous={diff.previous.time}
        />
      </Stack>
      <Stack gap="0">
        <TextWrapper fw={600}>Timezone</TextWrapper>
        <WordsDiff
          showRemoved={showRemoved}
          current={diff.current.timezone}
          previous={diff.previous.timezone}
        />
      </Stack>
    </>
  );
}
